export const isEmptyValue = ({ valueCheck, display }) => {
  let res = '-'
  if (typeof valueCheck === 'number') {
    res = display
  }
  return res
}
